import React, { useEffect, useState } from 'react';
import Heading from '../../../../../common/element/Heading';

import { setBreadcrumbs } from '../../../../../redux/Admin/breadcrumbsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getScienceOfSelfById } from '../../../../../redux/ScienceOfSelf/Scienceofselfslice';
import { setScienceOfSelfName, resetScienceOfSelfName } from '../../../../../redux/Admin/scienceOfSelfViewSlice';
import { useLocation, useNavigate } from 'react-router-dom';
import OverView from './OverView';
import SessionMaster from './ScienceOfSelfSession';
import ScienceOfSelfSessionView from './ScienceOfSelfSession/ScienceOfSelfSessionView';
import { CompanyAvatar } from '../../../../../common/element/CompanyAvatar/CompanyAvatar';
import AssignCoachDialog from './Coach/AddCoach';

// ✅ NEW: Import ImagePreviewModal
import ImagePreviewModal from '../../../../../common/ImagePreviewModal/ImagePreviewModal';

const ViewScienceOfSelf = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const idFromQuery = query.get('id');
  const tabFromQuery = query.get('tab') || 'overview';
  const sessionView = query.get('sessionView')
  const [activeTab, setActiveTab] = useState(tabFromQuery);
  const [isOpen, setIsOpen] = useState(false);

  // ✅ NEW: State for the Image Preview Modal
  const [imageModal, setImageModal] = useState({
    isOpen: false,
    url: "",
    alt: "",
  });

  const dispatch = useDispatch();

  const scienceId = idFromQuery ? parseInt(idFromQuery, 10) : null;
  const { data: scienceOfSelfDetail, loading } = useSelector((state) => state.scienceOfSelf.getScienceOfSelfById);
  const scienceOfSelfName = useSelector((state) => state.scienceOfSelfView?.scienceOfSelfName);
  const onNext = () => { setIsOpen(false) }

  useEffect(() => {
    const label = scienceOfSelfName || 'View Science of Self';
    dispatch(
      setBreadcrumbs([
        {
          label: 'Science of Self',
          url: '/scienceOfSelf',
          home: '/companies',
        },
        {
          label: label,
          url: `/scienceOfSelf/view?id=${scienceId}&tab=${tabFromQuery}`,
        },
      ])
    );
  }, [dispatch, scienceOfSelfName, scienceId]);

  useEffect(() => {
    if (scienceId) {
      dispatch(getScienceOfSelfById(scienceId));
    }
  }, [dispatch, scienceId]);

  useEffect(() => {
    if (scienceOfSelfDetail?.user) {
      const fullName = `${scienceOfSelfDetail.user.first_name || ''} ${scienceOfSelfDetail.user.last_name || ''}`.trim();
      if (fullName) {
        dispatch(setScienceOfSelfName(fullName));
      }
    }
  }, [dispatch, scienceOfSelfDetail]);

  useEffect(() => {
    return () => {
      dispatch(resetScienceOfSelfName());
    };
  }, [dispatch]);

  // Update URL when tab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    const params = new URLSearchParams(location.search);
    params.set('tab', tab);
    navigate(`${location.pathname}?${params.toString()}`, { replace: true });
  };

  // Sync activeTab with URL when user navigates back/forward
  useEffect(() => {
    const currentTab = query.get('tab') || 'overview';
    if (currentTab !== activeTab) {
      setActiveTab(currentTab);
    }
  }, [location.search]);

  // ✅ NEW: Image Preview Handlers
  const openImagePreview = () => {
    if (!scienceOfSelfDetail?.user?.profile_image) return;
    setImageModal({ 
      isOpen: true, 
      url: scienceOfSelfDetail.user.profile_image, 
      alt: `${scienceOfSelfDetail.user.first_name || ''} ${scienceOfSelfDetail.user.last_name || ''}`.trim() || "Profile Image" 
    });
  };

  const closeImagePreview = () => {
    setImageModal({ isOpen: false, url: "", alt: "" });
  };

  return (
    <div>
      <div className="flex justify-between mb-5">
        <div className="w-full">
          {sessionView == "view" ? "" : <>     {/* Header */}
            <div className="flex items-center gap-4 mb-6">
              
              {/* ✅ NEW: Wrap CompanyAvatar in clickable div */}
              <div 
                onClick={openImagePreview}
                className={scienceOfSelfDetail?.user?.profile_image ? "cursor-pointer hover:opacity-80 transition" : ""}
                title={scienceOfSelfDetail?.user?.profile_image ? "View Profile Image" : ""}
              >
                <CompanyAvatar logo={scienceOfSelfDetail?.user?.profile_image} name={scienceOfSelfDetail?.user?.first_name + " " + scienceOfSelfDetail?.user?.last_name} />
              </div>

              <div>
                <Heading>
                  {(scienceOfSelfDetail?.user && `${scienceOfSelfDetail.user.first_name} ${scienceOfSelfDetail.user.last_name}`) ||
                    '-'}
                </Heading>
                <div className="flex items-center gap-3 mt-1">
                  <div className={`flex items-center gap-1 px-3 py-0.5 ${scienceOfSelfDetail?.user?.isActive ? 'bg-[#ECFDF3]' : 'bg-[#FEF3F2]'} rounded-[16px]`}>
                    <div className={`w-2 h-2 ${scienceOfSelfDetail?.user?.isActive ? 'bg-green-500' : 'bg-red-600'} rounded-full`}></div>
                    <span className={`font-lato font-medium text-[14px] ${scienceOfSelfDetail?.user?.isActive ? 'text-[#027A48]' : 'text-[#B42318]'}`}>
                      {scienceOfSelfDetail?.user?.isActive ? 'Active' : 'Inactive'}
                    </span>
                  </div>
                    <span className="font-lato font-medium text-[14px] text-[#1D2939] flex items-center gap-2">

                  <span>{scienceOfSelfDetail?.user?.email}</span> •  <span>{scienceOfSelfDetail?.user?.mobile_number }</span>
                </span>
                
                </div>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex gap-0 p-1 bg-[#FFF4E5] border border-[#FFF4E5] rounded-lg mb-6">
              {['overview', 'sessions'].map((tab) => (
                <button
                  key={tab}
                  onClick={() => handleTabChange(tab)}
                  className={`flex-1 text-sm font-normal transition-colors py-2 px-3 rounded-md ${activeTab === tab
                    ? 'text-gray-900 bg-white shadow-[0px_1px_3px_rgba(16,24,40,0.1),0px_1px_2px_rgba(16,24,40,0.06)]'
                    : 'text-gray-600 bg-[#FFF4E5]'
                    }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                </button>
              ))}
            </div></>}


          {/* Tab Content */}
          {activeTab === 'overview' && (
            <>
              <OverView data={scienceOfSelfDetail} loading={loading}></OverView>
              {/* <CoachInfoCard coachData={coachDetail} /> */}
              <div className="mt-5">
                {/* <CompaniesChart /> */}
              </div>
            </>
          )}

          {activeTab === 'sessions' && (
            <>
              {sessionView == "view" ? <ScienceOfSelfSessionView /> : <SessionMaster></SessionMaster>}
            </>
          )}


        </div>
      </div>
      <AssignCoachDialog
        dialogOpen={isOpen}
        onDialogClose={() => setIsOpen(false)}
        onNext={onNext}
      />

      {/* ✅ NEW: Render the Image Preview Modal */}
      <ImagePreviewModal
        isOpen={imageModal.isOpen}
        onClose={closeImagePreview}
        imageUrl={imageModal.url}
        altText={imageModal.alt}
      />
      
    </div>
  );
};

export default ViewScienceOfSelf;